<template>
  <v-app id="inspire" class="gb">
    <div
        class="header-container"
        v-show="!(this.$route.path == '/chat/qr' || this.$route.path == '/chat' || this.$route.path.startsWith('/client/sign_up') || this.$route.path == '/download' || this.$route.path == '/my-market')"
    >
      <div class="module-container">
        <site-header
            v-if="!this.$store.getters['Authenticate/isLoggedIn']"
        ></site-header>
        <site-header-login
            v-if="this.$store.getters['Authenticate/isLoggedIn']"
        ></site-header-login>
      </div>
    </div>
    <div class="header-container" v-show="this.$route.path == '/chat'">
      <div class="module-container">
        <site-header-chat></site-header-chat>
      </div>
    </div>
    <connection-banner/>
    <cancellation-banner/>
    <mobile-desktop-banner v-show="this.$route.path.includes('/sign_up')"/>
    <div class="banner-container" v-show="!(this.$route.path == '/chat/qr' || this.$route.path == '/owner/alerts')">
      <div class="module-container">
        <nav-app v-if="this.$store.getters['Banner/showBanner']"/>
      </div>
    </div>
    <div class="banner-container warning" v-show="!(this.$route.path == '/chat/qr' || this.$route.path == '/owner/alerts')">
      <div class="module-container">
        <NavPaymentBanner v-if="!accountEnabledPermission"/>
      </div>
    </div>
    <div
        v-bind:class="{
				'module-container custom-top': this.$route.path.search('/chat') === -1 &&
				this.$route.path.search('/terms_and_conditions') === -1 &&
				this.$route.path.search('/privacy') === -1 &&
				this.$route.path.search('/licenses') === -1 &&
				this.$route.path.search('/my-market') === -1
			}"
    >
      <router-view/>
    </div>
    <div
        class="footer-container"
        v-show="!(this.$route.path == '/chat/qr' || this.$route.path == '/chat' || this.$route.path.startsWith('/client/sign_up') || this.$route.path == '/download' || this.$route.path == '/login' || this.$route.path == '/my-market')"
    >
      <site-footer class="module-container"></site-footer>
    </div>
    <div id="popups"></div>
    <free-tier-agreement-modal v-if="should_show_free_tier_modal" />
  </v-app>
</template>

<script lang="ts">
  import SiteHeader from '@/components/layout/SiteHeader.vue';
  import SiteHeaderLogin from '@/components/layout/SiteHeaderLogin.vue';
  import SiteHeaderChat from '@/components/layout/SiteHeaderChat.vue';
  import SiteFooter from '@/components/layout/SiteFooter.vue';
  import navApp from '@/components/nav/navApp.vue';
  import ConnectionBanner from '@/components/nav/ConnectionBanner.vue';
  import CancellationBanner from '@/components/nav/CancellationBanner.vue';
  import MobileDesktopBanner from '@/components/nav/MobileDesktopBanner.vue';
  import FreeTierAgreementModal from '@/components/legal/free_tier_agreement_modal.vue';
  import config from '@/config/constants.js';
  import {firestore} from "@/config/firebase";
  import {mapState} from "vuex";
  import PaymentMixin from '@/mixins/payment';
  import NavPaymentBanner from '@/components/nav/NavPaymentBanner.vue';

  export default {
    name: 'Web',
    mixins: [PaymentMixin],
    components: {
      'site-header': SiteHeader,
      'site-footer': SiteFooter,
      'site-header-login': SiteHeaderLogin,
      'site-header-chat': SiteHeaderChat,
      'nav-app': navApp,
      'connection-banner': ConnectionBanner,
      'cancellation-banner': CancellationBanner,
      'mobile-desktop-banner': MobileDesktopBanner,
      'free-tier-agreement-modal': FreeTierAgreementModal,
      NavPaymentBanner
    },
    data() {
      return {
        suscriptions: []
      }
    },
    watch: {
      user(val) {
        if (val) {
          this.unsubscribe();
          this.init();
        } else {
          this.unsubscribe();
        }
      },
    },
    created() {
      this.$store.dispatch('Connection/startListening');
      this.init();
    },
    computed: {
      ...mapState({
        user: state => state.Authenticate.user
      }),
      // Legacy free tenants (tenant.pricing_mode === 'free') were granted
      // a free market by an admin before the inline acceptance on
      // /sign_up/billing existed. Surface the Free Tier Partner Agreement
      // as a one-time popup on login until they accept the current
      // version. Owners only — vendors / employees / clients on a free
      // tenant don't see it (the agreement is owner-level partnership).
      // Re-evaluates automatically when the user/tenant doc listener
      // commits an update via Authenticate/updateUser, so logout / tenant
      // switch / acceptance writes all flow through here.
      should_show_free_tier_modal() {
        const user = this.user;
        if (!user) return false;
        if (user.user_role !== 'owner') return false;
        // Tenant fields are merged onto user via getUser() server-side
        // (jsonConcat) and updated live by the tenant doc listener in
        // init() — so user.pricing_mode is the tenant's pricing_mode.
        if (user.pricing_mode !== 'free') return false;
        if (user.free_terms_accepted_version === config.free_terms_current_version) return false;
        return true;
      }
    },
    methods: {
      init() {
        const self = this;
        if (self.user) {
          console.log('self user', self);
          self.suscriptions.push(firestore.collection("users").doc(self.user.owner_id)
              .onSnapshot(doc => {
                if (doc.exists) {
                  const user = doc.data();
                  self.$store.commit("Authenticate/updateUser", user);
                  const tenant = user.tenants_list.find(x => x.tenant_id === self.user.tenant_id && x.status === "inactive");
                  if (tenant) {
                    self.$store.commit("Authenticate/logout");
                  }
                }
              }, error => {
                console.error('[Web] Global user listener error:', error);
              }));

          if (self.user.user_role !== "owner") {
            self.suscriptions.push(firestore.collection("tenants").doc(self.user.tenant_id).collection("users").doc(self.user.id)
                .onSnapshot(doc => {
                  if (doc.exists) {
                    const user = doc.data();
                    self.$store.commit("Authenticate/updateUser", user);
                    if (user.is_active === false || user.disabled_by_agent_owner === true) {
                      self.$store.commit("Authenticate/logout");
                      return;
                    }
                    if (user.billing_active === false && user.user_role === "vendor") {
                      self.$router.push('/vendor/billing');
                    }
                  }
                }, error => {
                  console.error('[Web] Tenant user listener error:', error);
                }));
          }
          // Tenant doc listener — runs for EVERY role (owner, agent admin,
          // vendor, employee). Surfaces tenant-level billing state so the
          // cancellation banner + role-specific lockout (agent admins to
          // /owner/billing reactivate, vendors to /owner/account data
          // export) can react reactively to a cancel-scheduled / cancel-
          // fired transition mid-session.
          self.suscriptions.push(firestore.collection("tenants").doc(self.user.tenant_id)
              .onSnapshot(doc => {
                if (!doc.exists) return;
                const tenant = doc.data();
                self.$store.commit("Authenticate/updateTenant", {
                  billing_active: tenant.billing_active,
                  billing_status: tenant.billing_status,
                  cancel_scheduled_at: tenant.cancel_scheduled_at || null,
                  cancel_effective_at: tenant.cancel_effective_at || null,
                  canceled_at: tenant.canceled_at || null,
                  company_name: tenant.company_name || null,
                  owner_id: tenant.owner_id || null,
                });
                // Legacy flow: the OLD owner-branch tenant listener
                // committed the full tenant doc as the user (via
                // updateUser) — that's how state.user.billing_active
                // (and downstream paymentPermission) actually stayed in
                // sync with the tenant's billing state. paymentPermission
                // reads state.user.billing_active for owners, so without
                // this commit, billing_active never flips back to true
                // after reactivate and the user stays locked out.
                if (self.user.user_role === 'owner') {
                  self.$store.commit("Authenticate/updateUser", tenant);
                }
                // Owner-only redirect on hard-cancel — keeps the previous
                // behavior. Non-owner redirects happen via the global
                // router guard reading tenant_billing_state. Skip when
                // we're already on /owner/billing to avoid the
                // NavigationDuplicated noise vue-router throws when the
                // target is the current route.
                if (
                  self.user.user_role === 'owner'
                  && tenant.billing_active === false
                  && self.$route.path !== '/owner/billing'
                ) {
                  self.$router.push('/owner/billing').catch(() => {});
                }
              }, error => {
                console.error('[Web] Tenant doc listener error:', error);
              }));
        }
      },
      unsubscribe() {
        for (const suscription of this.suscriptions) {
          suscription ? suscription() : '';
        }
        // Reset so a subsequent init() doesn't re-push onto an array of
        // already-cancelled handles. Without this, every tenant switch
        // (which fires the user watcher → unsubscribe → init) grows the
        // array unboundedly.
        this.suscriptions = [];
      },
    }
  };
</script>

<style lang="scss">
  @import 'assets/css/style.scss';
  @import 'assets/css/app.scss';
  @import 'assets/css/responsive/admin.scss';
</style>

<style lang="scss">
  .banner-container {
    /*padding-top: 113px;*/
  }

  .v-content {
    padding-top: 0 !important;

    &.gb,
    .page,
    &.page {
      padding-top: 0 !important;
    }
  }

  @media (max-width: 1200px) {
    #inspire {
      background: #ffffff;
    }
  }
</style>
